import posthog from 'posthog-js'

var selectedInput = undefined;

window.isNumberKey = function isNumberKey(evt) {
  var charCode = (evt.which) ? evt.which : event.keyCode;
  if (charCode != 43 &&  charCode > 31
      && (charCode < 48 || charCode > 57))
    return false;

    return true;
}

window.refreshJsInitializers = function() {
  window.initAlpineElements();
  window.selectOnFocus();
  window.initTooltips();
}

window.submitSearchForm = function() {
  const searchBtn = document.querySelector('#search-submit');
  if (searchBtn) {
    searchBtn.click();
  }
}

window.updateSearchFromPropertiesModal = function(event) {
  // Update search when display properties modal checkbox changes
  // Syncs to ALL forms with id="search-form-tab" (both inline and advanced forms)
  const target = event.target;
  const label = target.closest('label');

  // Show loading spinner to prevent multiple submissions
  if (label) {
    label.classList.add('disabled');
    label.innerHTML = `<div class="circle-spinner-border" style="height: 1rem; width: 1rem;"></div>
                        ${label.innerText}`;
    const modalFrame = document.getElementById('display-properties-modal-frame');
    if (modalFrame) {
      modalFrame.style.pointerEvents = 'none';
    }
  }

  // Sync modal checkbox state to ALL display column containers
  // There are two forms with id="search-form-tab": inline form and advanced form
  // Each has its own display columns container
  const sourceForm = target.dataset.sourceForm;
  const modalCheckboxId = target.id;

  // Find all display column containers and sync to all of them
  const allDisplayColumnContainers = document.querySelectorAll('[id$="_display_columns"]');

  allDisplayColumnContainers.forEach(container => {
    const targetCheckboxId = `filter_${modalCheckboxId}`;
    const targetCheckbox = container.querySelector(`#${CSS.escape(targetCheckboxId)}`);

    if (targetCheckbox) {
      targetCheckbox.checked = target.checked;
    }
  });

  // Find the appropriate submit button based on source_form
  const searchSubmitBtnId = sourceForm === 'inline_search_form' ? '#inline-search-submit' : '#search-submit';
  const searchBtn = document.querySelector(searchSubmitBtnId);

  if (!searchBtn) {
    console.error(`Search submit button not found: ${searchSubmitBtnId}`);
    return;
  }

  const form = searchBtn.closest('form');
  if (!form) {
    console.error('Form not found');
    return;
  }

  // Check if this is a Vue.js page or Stimulus page
  const vueInstance = window.findVueSearchInstance();

  if (vueInstance && vueInstance.search_clauses_attributes) {
    // Vue.js pages: sync Vue data first, then submit
    window.captureVueSearchClauses('vue-sync-field-display', () => {
      form.requestSubmit(searchBtn);
    });
  } else {
    // Stimulus pages (variants, reports): submit directly
    form.requestSubmit(searchBtn);
  }
}

window.selectAllPermissions = function(category, sub_category) {
  const itemCheckboxes =  document.querySelectorAll(`#permissions_${category}_${sub_category} .check_boxes`);
  itemCheckboxes.forEach(checkbox => {
    checkbox.checked = true;
  });
}

window.unselectAllPermissions = function(category, sub_category) {
  const itemCheckboxes =  document.querySelectorAll(`#permissions_${category}_${sub_category} .check_boxes`);
  itemCheckboxes.forEach(checkbox => {
    checkbox.checked = false;
  });
}

window.initAlpineElements = function() {
  var alpineElms = document.querySelectorAll('[x-data]');
  for (var i = 0; i < alpineElms.length; i++) {
    Alpine.initializeComponent(alpineElms[i]);
  }
}

window.initTooltips = function() {
  $('[data-toggle="tooltip"]').tooltip()
}

window.selectOnFocus = function() {
  $(document).off('focus.selectOnFocus', 'input:text').on('focus.selectOnFocus', 'input:text', function() {
    this.select();
  });
}

window.clearEphemeralElements = function() {
  $('body.is--dirty').removeClass('is--dirty');
  $('[role="tooltip"], .dirtylisten.dirty .dirty-form-actions').remove();

  $('.dropdown-menu.show').dropdown('hide');
}

window.copyStripeLink = function() {
  var copyText = document.querySelector("#stripe-link");
  copyText.select();
  copyText.setSelectionRange(0, 99999)
  document.execCommand("copy");
  alert("Copied: " + copyText.value);
}

window.addCompany = function(event, customerID) {
  event.stopPropagation();
  event.stopImmediatePropagation();

  $(`#company_${customerID}_form_copy`).addClass('d-flex')
  document.getElementById(`company_${customerID}_form_copy`).style.display = 'block';
  document.getElementById(`company_${customerID}_form_copy_input`).focus();
  document.getElementById(`add_company_${customerID}`).style.setProperty('display', 'none', 'important');
}

window.removeCompanyForm = function(event, customerID) {
  event.stopPropagation();
  event.stopImmediatePropagation();
  document.getElementById(`add_company_${customerID}`).style.setProperty('display', 'block', 'important');
  document.getElementById(`company_${customerID}_form_copy_input`).value = '';
  document.getElementById(`company_${customerID}_form_copy`).style.setProperty('display', 'none', 'important');
}

window.submitForm = function(event, customerID) {
  event.stopPropagation();
  event.stopImmediatePropagation();
  posthog.capture('create_company_from_sales_select_customer')

  var value = $(`#company_${customerID}_form_copy_input`).val();
  $(`#company_${customerID}_form input`)[0].value = value
  $(`#company_${customerID}_form_copy_input`)[0].value = ''
  $(`#company_${customerID}_submit`).prop('disabled', false);
  $(`#company_${customerID}_submit`)[0].click();
  document.getElementById(`company_${customerID}_form_copy`).style.setProperty('display', 'none', 'important');
  document.getElementById(`add_company_${customerID}`).style.setProperty('display', 'block', 'important');
}

window.copyPaymentLink = function(paymentLink) {
  document.getElementById("payment-link").setAttribute('value', paymentLink);
  var copyText = document.querySelector("#payment-link");
  copyText.select();
  copyText.setSelectionRange(0, 99999)
  document.execCommand("copy");
  alert("Copied: " + copyText.value);
}

window.showLogoPreview = function(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $('#logo_prev').attr('src', e.target.result)
    };

    reader.readAsDataURL(input.files[0]);
  }
}

window.modalHideAndDispose = function(modal) {
  $(modal).removeClass('show');
  $('.modal-backdrop').remove();
  $('body').removeClass('modal-open');
  $(modal).remove();
}

window.modalShow = function(modal) {
  $('.modal.show').each(function() {
    window.modalHideAndDispose(this);
  })

  setTimeout(function() {
    $(modal).modal('show');
    document.dispatchEvent(new Event('load:components'));
  }, 10)

  return modal;
}

window.addCleaveFormatters = function() {
  $('.input-price').toArray().forEach(function(field){
    new Cleave(field, {
      numeral: true,
      numeralPositiveOnly: field.dataset.onlyPositive,
      swapHiddenInput: true,
      numeralThousandsGroupStyle: 'thousand',
      numeralDecimalScale: field.dataset.decimals
    });
  });
}

window.removeExistingModalById = function(modalId) {
  var existingModal = document.getElementById(modalId);
  if (existingModal) {
    window.modalHideAndDispose(existingModal);
  }
}

window.addModalAndShow = function(html) {
  var fragment = document.createRange().createContextualFragment(html);
  var modalsWrapper = document.getElementById('modals');

  modalsWrapper.appendChild(fragment);
  var modal = modalsWrapper.lastElementChild;

  window.refreshJsInitializers();

  return window.modalShow(modal);
}

window.bootstrapToggle = function($el, status, classShow) {
  if (status) {
    bootstrapShow($el, classShow);
  } else {
    bootstrapHide($el);
  }
}
window.bootstrapHide = function($el) {
  $el.removeClass('d-block d-table-row').addClass('d-none');
}
window.bootstrapShow = function($el, classShow) {
  $el.removeClass('d-none').addClass(classShow ? classShow : 'd-block');
}

/*!
 * Determine if an element is in the viewport
 * https://vanillajstoolkit.com/helpers/isinviewport/
 */
window.isInViewport = function (elem) {
  var distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

window.formatMoney = function(currency, amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount)
}

window.showModalPanel = function(panelsSelector, panelNameToShow) {
  var modalPanels = document.querySelectorAll(panelsSelector);
  for (var i = 0; i < modalPanels.length; i++) {
    var modalPanel = modalPanels[i];
    if (modalPanel.dataset.panel === panelNameToShow) {
      modalPanel.classList.add(modalPanel.dataset.panelClassActive);
      modalPanel.classList.remove(modalPanel.dataset.panelClassInactive);
    } else {
      modalPanel.classList.add(modalPanel.dataset.panelClassInactive);
      modalPanel.classList.remove(modalPanel.dataset.panelClassActive);
    }
  }
}

window.safeStartTurboProgress = function() {
  if (Turbo.navigator.delegate.adapter.progressBar != undefined) {
    try {
      Turbo.navigator.delegate.adapter.progressBar.setValue(0);
      Turbo.navigator.delegate.adapter.progressBar.show();
    } catch(err) { }
  }
}

window.safeStopTurboProgress = function() {
  if (Turbo.navigator.delegate.adapter.progressBar != undefined) {
    try {
      Turbo.navigator.delegate.adapter.progressBar.setValue(100);
      Turbo.navigator.delegate.adapter.progressBar.hide();
    } catch(err) { }
  }
}

window.stopLinkPropagation = function(event) {
  event.stopPropagation()
}

window.salesOrderLineItemUnitPriceEdit = function(unit_price, discount_amount, discount_type, surcharge_amount, surcharge_type) {
  return {
    unit_price: unit_price,
    discount_amount: discount_amount,
    discount_type: discount_type,
    surcharge_amount: surcharge_amount,
    surcharge_type: surcharge_type,
    showDiscountReason: function() {
      var discount = parseFloat(this.discount_amount.replace(/,/g, ''));
      if (isNaN(discount) || discount < 0) discount = 0;

      return discount > 0;
    },
    subtotal: function() {
      var price = parseFloat(this.unit_price.replace(/,/g, '')),
          discount = parseFloat(this.discount_amount.replace(/,/g, '')),
          surcharge = parseFloat(this.surcharge_amount.replace(/,/g, ''));

      if (isNaN(price) || price < 0) price = 0;
      if (isNaN(discount) || discount < 0) discount = 0;
      if (isNaN(surcharge) || surcharge < 0) surcharge = 0;

      if (discount > 0 && this.discount_type === 'percentage') {
        discount = discount / 100 * price;
      }
      if (surcharge > 0 && this.surcharge_type === 'percentage') {
        surcharge = surcharge / 100 * price;
      }

      return (price - discount + surcharge).toLocaleString('en-US', { maximumFractionDigits:2 });
    }
  };
}

window.paymentChange = function(balance_due, payment_amount) {
  return {
    balance_due: balance_due,
    payment_amount: payment_amount,
    showStoreChange: function() {
      var balance_due = parseFloat(this.balance_due.replace(/,/g, '')),
      payment_amount = parseFloat(this.payment_amount.replace(/,/g, ''));
      return payment_amount > balance_due;
    },
    changeAmount: function() {
      var balance_due = parseFloat(this.balance_due.replace(/,/g, '')),
          payment_amount = parseFloat(this.payment_amount.replace(/,/g, ''));

      if (isNaN(balance_due) || balance_due < 0) balance_due = 0;
      if (isNaN(payment_amount) || payment_amount < 0) payment_amount = 0;

      return Math.max(0, payment_amount - balance_due).toLocaleString('en-US', { maximumFractionDigits:2 });
    }
  };
}

window.selectAll = function() {
  var totals = document.querySelectorAll('.select-link');
  for (var i = 0; i < totals.length; i++) {
    var span = totals[i]
    span.click();
  }
}

window.sumTotalCreditToApply = function(element, parentId) {
  var parent = element.closest(parentId)
  var items = parent.querySelectorAll('.to-sum');
  var tot=0;
  for (var i = 0; i < items.length; i++) {
    if(parseFloat(items[i].value))
            tot += parseFloat(items[i].value);
  }

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  var totals = parent.querySelectorAll('#total');
  for (var i = 0; i < totals.length; i++) {
    var span = totals[i]
    span.innerText = span.textContent = formatter.format(tot);
  }

  var totals = document.querySelectorAll('#change-amount');
  for (var i = 0; i < totals.length; i++) {
    var paymentAmount = parseFloat(document.querySelector('input[name="payment[amount]"]').value)
    var span = totals[i]
    span.innerText = span.textContent = paymentAmount - tot;
  }

  var diffs = parent.querySelectorAll('#diff-to-apply');
  for (var i = 0; i < diffs.length; i++) {
    var span = diffs[i]
    var diff = span.dataset.total - tot;
    span.innerText = span.textContent = formatter.format(diff);
  }

  // Check if show/hide partial refund error
  if ($('#total_amount_paid').length) {
    var totalAmountPaid = $('#total_amount_paid')[0].dataset.totalAmountPaid
    if (parseFloat(tot) == 0 || (parseFloat(totalAmountPaid) == parseFloat(tot))) {
      $('#partial_error').attr("hidden", true);
      $('#save_btn').prop('value', 'Save');
    } else {
      $('#save_btn').prop('value', 'Schedule refund');
      $('#partial_error').attr("hidden", false);
    };
  }
}

window.clearPaymentIframe = function() {
  var iframe = document.getElementById('tokenFrame');
  if (iframe) { iframe.src = iframe.src; }
  var cardToken = document.getElementById('card-token');
  if (cardToken) {cardToken.value = '';}
  var inputCard = $('#Field-numberInput');
  if (inputCard) { inputCard.value = undefined; }
  $("#apply_button").attr("disabled", true);
}

window.clearCustomerPaymentInput = function(){
  var customerPayment = document.getElementById('payment_customer_payment_method_id')
  if (customerPayment) customerPayment.selectedIndex = -1;
}

window.clearTerminalInput = function(){
  var terminalSelection = document.getElementById('payment_payment_terminal_id')
  if (terminalSelection) { terminalSelection.selectedIndex = -1; }
}


window.initKeyboard = function(){
  if (window.SimpleKeyboard != undefined) {
    if (!$('.simple-keyboard').length) {
      return;
    }
    let layout;
    let buttonTheme;

    if ($('.input').attr('id') == 'pin-input') {
      layout = { default: ["7 8 9", "4 5 6", "1 2 3", "- 0 {bksp}", "{enter}"] };
      buttonTheme = [{
        class: "hg-standardBtn",
        buttons: "{bksp}"
      }]
    } else if ($('.input').attr('id') == 'cash-input') {
      layout = { default: ["7 8 9", "4 5 6", "1 2 3", ". 0 {bksp}", "{enter}"] } ;
      buttonTheme = [{
        class: "hg-standardBtn",
        buttons: "{bksp}"
      }]
    } else {
      layout = {
        default: [
          "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          "{tab} q w e r t y u i o p [ ] \\",
          "{lock} a s d f g h j k l ; ' {enter}",
          "{shift} z x c v b n m , . / {shift}",
          ".com @ {space}",
        ],
        shift: [
          "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
          "{tab} Q W E R T Y U I O P { } |",
          '{lock} A S D F G H J K L : " {enter}',
          "{shift} Z X C V B N M < > ? {shift}",
          ".com @ {space}",
        ]
      };
    }

    const Keyboard = window.SimpleKeyboard.default;

    const myKeyboard = new Keyboard({
      onChange: input => onChange(input),
      onKeyPress: button => onKeyPress(button),
      layout: layout,
      buttonTheme: buttonTheme,
      display: {
        '{bksp}': '<i class="fas fa-backspace"></i>',
        '{enter}': 'Enter',
        '{space}': ' ',
        '{shift}': 'Shift',
        '{lock}': 'caps lock',
        '{tab}': 'tab'
      }
    });

    $('.input').each(function() {
      myKeyboard.setInput(this.value, this.id);
    })

    function onChange(input) {
      if (selectedInput == undefined) selectedInput = '.input'
      document.querySelector(selectedInput).value = input;
    }

    function onKeyPress(button) {
      if (button === "{enter}") {
        var form = $('#keyboard-submit-form');
        window.Rails.fire(form[0], 'submit')
      }
      if (button === "{shift}" || button === "{lock}") handleShift();
    }

    function handleShift() {
      let currentLayout = myKeyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      myKeyboard.setOptions({
        layoutName: shiftToggle
      });
    }

    document.querySelectorAll(".input").forEach(input => {
      input.addEventListener("focus", onInputFocus);
      input.addEventListener("input", onInputChange);
    });

    function onInputFocus(event) {
      selectedInput = `#${event.target.id}`;

      myKeyboard.setOptions({
        inputName: event.target.id
      });
    }

    function onInputChange(event) {
      myKeyboard.setInput(event.target.value, event.target.id);
    }
  }
}

/**
 * Event handler for Turbo's before-fetch-response event
 * This code automatically closes any open modals when navigating between pages,
 * except for specific cases where we want to keep modals open.
 *
 * The event fires when Turbo receives a response from the server but before it processes it.
 * We check if the response is successful (ok) and then determine if we should close modals.
 */
$(document).on('turbo:before-fetch-response', function (e) {
  if (e.detail.fetchResponse.response.ok) {
    // List of element IDs where we DON'T want to close modals (exact matches)
    var excludedIds = ['', ' ', 'inventory_adjustments', 'kits', 'available', 'incoming', 'forecast', 'sales_history', 'product_modal_frame',
      'gallery_images_frame', 'variant_modal_frame', 'price_list_modal_frame', 'replenishment', 'activities', 'incoming_content', 'available_content',
      'new_cross_reference', 'price_list_msrp', 'display-properties-search-form-tab', 'turbo_modal_frame', 'shipping_estimates_select',
      'sales-history-invoices-list'];

    // List of IDs containing these substrings should not trigger modal closures, specifically for forms that are being submitted within the modal.
    var excludedSubstrings = ['edit_product_photo_', 'edit_custom_attribute_customizable_', 'edit_product_', 'edit_price_list_variant_', 'edit_variant_', 'new_price_list_variant_'];

    // Get the target ID safely
    var targetId = '';
    if (e.target && typeof e.target.id === 'string') {
      targetId = e.target.id;
    }

    // Check if the target ID is excluded (either exact match or contains an excluded substring)
    var isExcluded = excludedIds.indexOf(e.target.id) !== -1;
    if (!isExcluded && targetId) {
      // Check for substring matches
      for (var i = 0; i < excludedSubstrings.length; i++) {
        if (e.target.id.indexOf(excludedSubstrings[i]) !== -1) {
          isExcluded = true;
          break;
        }
      }
    }

    // Only close modals if the target element's ID is not excluded
    if (e.target.id != 'global-search-form' &&
        e.target.id != 'global-search-results' &&
        e.target.id != 'more-results' &&
        !isExcluded) {
      $('.modal').each(function(e){
        $('.modal').modal('hide')
      });
    }
  }
})

$(document).on('turbo:load load:components', function () {
  // window.initKeyboard();

  $('.reset_value').change(function() {
    if ($(this).is(":checked")) {
      var select = $(this).closest('.form-group').parent().find('.custom-select')
      console.log($(this).closest('.form-group').parent())
      select.prop('disabled', 'disabled');
    }
    else {
      var select = $(this).closest('.form-group').parent().find('.custom-select')
      select.prop('disabled', false);
    }
  });

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    var href = e.target.href;
    if (href.includes("terminal")){
      process.nextTick(() => {
        clearPaymentIframe();
        clearCustomerPaymentInput();
        document.getElementById('apply_button').disabled = false;
      });
    } else if (href.includes("manual_entry")){
      process.nextTick(() => {
        $("#apply_button").attr("disabled", true);
        clearCustomerPaymentInput();
        clearTerminalInput();
      });
    } else if (href.includes("saved_card")){
      process.nextTick(() => {
        clearPaymentIframe();
        clearTerminalInput();
        document.getElementById('apply_button').disabled = false;
      });
    };
  })

  $('.modal').on('hide.bs.modal', function (e) {
    const indicator = document.getElementById("modal-indicator")

    if (indicator && indicator.value=="submitted") {
      e.preventDefault();
    }
  });

  $('#new_sales_order').on('keypress', e => {
    if (e.keyCode == 13) {
      return false;
    }
  });

  window.initPhoneInputs();

  window.addEventListener('message', function(event) {
    try {
      var token = JSON.parse(event.data);
      if (token.message){
        var cardToken = document.getElementById('card-token');
        var expiry = document.getElementById('expiry');
        if (cardToken) {
          cardToken.value = token.message;
          console.log('por acaaa')
          $("#apply_button").removeAttr("disabled");
          if (expiry) {
            expiry.value = token.expiry;
          }
        }
      }
    }
    catch (e) {
    }
  }, false);

  function OTPInput() {
    const inputs = document.querySelectorAll('#otp > *[id]');

    if (inputs[0] != undefined ){
      // Add paste handler to ALL inputs so pasting works regardless of which input is focused
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("paste", function (event) {
          event.preventDefault();

          const pastedValue = (event.clipboardData || window.clipboardData).getData("text").trim();
          const otpLength = inputs.length;

          for (let j = 0; j < otpLength; j++) {
            if (j < pastedValue.length) {
              inputs[j].value = pastedValue[j];
            } else {
              inputs[j].value = ""; // Clear any remaining inputs
            }
          }

          // Focus the last filled input or the last input if all filled
          const lastFilledIndex = Math.min(pastedValue.length - 1, otpLength - 1);
          if (lastFilledIndex >= 0) {
            inputs[lastFilledIndex].focus();
          }
        });

        inputs[i].addEventListener('keydown', function(event) {
          if (event.key==="Backspace" ) {
            inputs[i].value='' ;
            if (i !==0) inputs[i - 1].focus();
          } else {
            if (i===inputs.length - 1 && inputs[i].value !=='' ) {
              return true;
            }
            else if (event.keyCode> 47 && event.keyCode < 58) {
              inputs[i].value=event.key;
              if (i !==inputs.length - 1) inputs[i + 1].focus();
              event.preventDefault();
            } else if (event.keyCode> 64 && event.keyCode < 91) {
              // inputs[i].value=String.fromCharCode(event.keyCode);
              // if (i !==inputs.length - 1) inputs[i + 1].focus();
            }
          }
        });
      }
    }
  }
  OTPInput();

});

function initMap() {
  // Create an info window to share between markers.
  const infoWindow = new google.maps.InfoWindow({
    content: "",
    disableAutoPan: true,
  });

  const coords = document.getElementById("default-location-address");
  const city = {
    lat: parseFloat(coords.getAttribute("data-latitude")),
    lng: parseFloat(coords.getAttribute("data-longitude"))
  };

  const map = new google.maps.Map(document.getElementById("map"), {
    center: city,
    zoom: 12
  });

  // Location Addresses
  const icon = {
    url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
    scaledSize: new google.maps.Size(60, 60)
  };
  const locationAddresses = document.querySelectorAll("li.location-address-item");
  locationAddresses.forEach(address => {
    const marker = new google.maps.Marker({
      position: {
        lat: parseFloat(address.getAttribute("data-latitude")),
        lng: parseFloat(address.getAttribute("data-longitude"))
      },
      title: address.getAttribute("data-name") + '\n' + address.getAttribute("data-address"),
      map: map
    });
    marker.setIcon(icon);

    marker.addListener("click", () => {
      infoWindow.setContent(address.getAttribute("data-name") + "</a><br><br>" +
                            address.getAttribute("data-address"));
      infoWindow.open(map, marker);
    });
  })

  // Customer addresses
  const addresses = Array.from(document.querySelectorAll("li.address-list-item"));
  const markers = addresses.map((address, i) => {
    const marker = new google.maps.Marker({
      position: {
        lat: parseFloat(address.getAttribute("data-latitude")),
        lng: parseFloat(address.getAttribute("data-longitude"))
      },
      title: address.getAttribute("data-customer-name") + '\n\n' + address.getAttribute("data-address-name") +
             '\n' + address.getAttribute("data-customer-address"),
    });

    marker.addListener("click", () => {
      infoWindow.setContent("<a href='" + address.getAttribute("data-customer-url") + "' target='_blank'>" +
                            address.getAttribute("data-customer-name") + "</a><br><br>" +
                            address.getAttribute("data-address-name") + " <br> " +

                            address.getAttribute("data-customer-address"));
      infoWindow.open(map, marker);
    });
    return marker;
  });

  // Add a marker clusterer to manage the markers.
  new markerClusterer.MarkerClusterer({ markers, map });

  //https://developers.google.com/maps/documentation/javascript/geolocation?hl=es-419
  const locationButton = document.createElement("button");
  locationButton.textContent = "Pan to Current Location";
  locationButton.classList.add("custom-map-control-button");
  map.controls[google.maps.ControlPosition.TOP_CENTER].push(locationButton);
  locationButton.addEventListener("click", () => {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          infoWindow.setPosition(pos);
          infoWindow.setContent("Location found.");
          infoWindow.open(map);
          map.setCenter(pos);
        },
        () => {
          handleLocationError(true, infoWindow, map.getCenter());
        }
      );
    } else {
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter());
    }
  });

  function handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(
      browserHasGeolocation
      ? "Error: The Geolocation service failed."
      : "Error: Your browser doesn't support geolocation."
    );
    infoWindow.open(map);
  }
}

window.initMap = initMap;

document.addEventListener('turbo:frame-render', async e => {
  if (['search-results-frame'].includes(e.target.id))
    history.pushState(history.state, '', await e.detail.fetchResponse.location)

  window.refreshJsInitializers();
})


document.addEventListener('turbo:frame-load', function (e) {
  window.initPhoneInputs();
  if (e.target.id != 'customers_list' && e.target.id != 'products_list') {
    // window.initKeyboard();
  }
  window.refreshJsInitializers();
});

document.addEventListener("turbo:before-fetch-response", async e => {
  if (['display-properties-search-form-tab'].includes(e.target.id))
    history.pushState(history.state, '', await e.detail.fetchResponse.location)
  if (e.target.id == 'more-results') {
    const loadMore = document.getElementById('load-more')
    if (loadMore != undefined) {
      loadMore.remove();
    }
  }
  if ((e.target.id == 'search-form-tab') || (e.target.id == 'advance-search-frame')) {
    history.pushState({ turbo: true, url: window.eventUrl }, '', current_url);
  }
});

window.initPhoneInputs = function() {
  const inputs = document.querySelectorAll('[name="account[phone_number]"], input.tel');
  inputs.forEach(input1 => {
    const iti = window.intlTelInput(input1, {
      preferredCountries: ['us', 'ca'],
      hiddenInput: () => ({ phone: input1.getAttribute("name"), country: "country_code" }),
      initialCountry: 'us',
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.10/build/js/utils.js",
      separateDialCode: true
    });

    const handleChange = () => {
      var invalidClass = 'invalid-msg'
      var container = input1.parentElement.parentElement;
      var elements = container.getElementsByClassName(invalidClass);

      while (elements[0]) {
        elements[0].parentNode.removeChild(elements[0]);
      }

      var elements = container.getElementsByClassName("invalid-feedback");

      while (elements[0]) {
        elements[0].parentNode.removeChild(elements[0]);
      }

      if (input1.value && !iti.isValidNumber()) {
        var error_div = document.createElement('div'); // is a node
        error_div.className = invalidClass;
        error_div.innerHTML = 'Phone number is invalid';
        input1.parentElement.parentElement.appendChild(error_div);
      }
    };

    // listen to "keyup", but also "change" to update when the user selects a country
    input1.addEventListener('paste', handleChange);
    input1.addEventListener('change', handleChange);
    input1.addEventListener('keyup', handleChange);
  });
}

// Shared Vue.js search clauses capture utility functions
window.findVueSearchInstance = function() {
  const inlineSearchForm = document.getElementById('dynamic-search-form-inline');
  const advancedSearchForm = document.getElementById('dynamic-search-form');

  // Check inline form first (for desktop view)
  if (inlineSearchForm && inlineSearchForm.__vue__) {
    return inlineSearchForm.__vue__;
  }
  // Then check advanced form (for mobile/modal view)  
  else if (advancedSearchForm && advancedSearchForm.__vue__) {
    return advancedSearchForm.__vue__;
  }

  return null;
}

window.syncVueDataToSearchForm = function(vueInstance, fieldClass = 'vue-sync-field') {
  const searchForm = document.getElementById('search-form-tab');
  if (!searchForm || !vueInstance || !vueInstance.search_clauses_attributes) return;

  // Remove any existing search clause hidden fields to avoid duplicates
  const existingHiddenFields = searchForm.querySelectorAll('input[name*="search_clauses_attributes"]:not([id*="full_search"])');
  existingHiddenFields.forEach(field => {
    if (!field.closest('.dynamic-search-form') && field.classList.contains(fieldClass)) {
      field.remove();
    }
  });

  // Create hidden fields for each search clause that Vue.js manages
  vueInstance.search_clauses_attributes.forEach((clause, clauseIndex) => {
    if (clause._destroy !== 1) {
      // Add hidden fields for the clause
      addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][id]`, clause.id || '', fieldClass);
      addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][sk]`, clause.search_key, fieldClass);
      addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][sc]`, clause.search_comparator, fieldClass);
      addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][_destroy]`, clause._destroy || '', fieldClass);

      if (clause.custom_attribute_id) {
        addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][custom_attribute_id]`, clause.custom_attribute_id, fieldClass);
      }

      // Add hidden fields for search terms
      clause.search_terms.forEach((term, termIndex) => {
        if (term._destroy !== 1) {
          addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][sta][${termIndex}][id]`, term.id || '', fieldClass);
          addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][sta][${termIndex}][_destroy]`, term._destroy || '', fieldClass);

          if (term.value !== undefined && term.value !== null) {
            addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][sta][${termIndex}][value]`, term.value, fieldClass);
          }

          // Handle multi-level select values
          if (term.values && typeof term.values === 'object') {
            Object.keys(term.values).forEach(valueKey => {
              if (term.values[valueKey] !== undefined && term.values[valueKey] !== null) {
                addHiddenFieldToSearchForm(searchForm, `ps[sca][${clauseIndex}][sta][${termIndex}][values][${valueKey}]`, term.values[valueKey], fieldClass);
              }
            });
          }
        }
      });
    }
  });
}

function addHiddenFieldToSearchForm(form, name, value, fieldClass) {
  // Check if field already exists
  const existingField = form.querySelector(`input[name="${name}"]`);
  if (existingField && !existingField.closest('.dynamic-search-form')) {
    existingField.value = value;
    return;
  }

  // Create new hidden field
  const hiddenField = document.createElement('input');
  hiddenField.type = 'hidden';
  hiddenField.name = name;
  hiddenField.value = value;
  hiddenField.classList.add(fieldClass);
  form.appendChild(hiddenField);
}

window.captureVueSearchClauses = function(fieldClass = 'vue-sync-field', callback = null) {
  const vueInstance = window.findVueSearchInstance();

  if (vueInstance && vueInstance.search_clauses_attributes) {
    // Vue pages - sync Vue data first, then submit
    vueInstance.$forceUpdate();

    // Wait for Vue to update the DOM, then sync data
    vueInstance.$nextTick(() => {
      window.syncVueDataToSearchForm(vueInstance, fieldClass);
      if (callback && typeof callback === 'function') {
        callback();
      }
    });
  } else {
    // Stimulus pages (variants, reports) - submit immediately
    if (callback && typeof callback === 'function') {
      callback();
    }
  }
}

// Vue.js search clauses capture for display properties modal (backward compatibility)
window.captureVueSearchClausesForDisplayProperties = function() {
  window.captureVueSearchClauses('vue-sync-field-display');
}
